import { ModalStore } from '../../state/ModalStore'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

export default function StrategyCallButton({
    children = 'Book a Strategy Call',
    className = '',
    Modal = HomepageBookCallLeadModal,
}) {
    const addModal = ModalStore((state) => state.add)

    const handleClick = () => {
        addModal(<Modal />)
    }

    return (
        <button type="button" onClick={handleClick} className={className}>
            {children}
        </button>
    )
}
